import React, { Component } from 'react';  // eslint-disable-line no-unused-vars


function Page404(props){

  return (
    <div id="content-404">
    </div>
  )
}

export default Page404;




// WEBPACK FOOTER //
// ./src/components/Page404.js